import { ScannersList } from '@/components/hotel-access-code-scans';
import { useParams } from 'react-router-dom';

export function HotelGuestsTab() {
  const { id } = useParams<{ id: string }>();

  if (!id) return null;

  return <ScannersList hotelId={id} />;
}
